module.exports = __webpack_public_path__ + "media/images/abonne_moov-7aa3415d661c89d9a89973ca79f7062b.svg";